module.exports = __webpack_public_path__ + "static/media/erik.944fc18d.svg";